import * as React from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import '@ant-design/compatible/assets/index.css';
import { Input, Spin, Select, Button } from 'antd';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import Mapbox from '../mapbox/Mapbox';

const style = require('./LocationAutocomplete.less');

export class LocationAutocomplete extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			address: props.initialValue || '',
			streetAddress1: nullSafeGetOrElse('value.streetAddress1', props, ''),
			streetAddress2Opt: nullSafeGetOrElse('value.streetAddress2Opt', props, ''),
			city: nullSafeGetOrElse('value.city', props, ''),
			region: nullSafeGetOrElse('value.region', props, ''),
			postcode: nullSafeGetOrElse('value.postcode', props, ''),
		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.initialValue !== this.props.initialValue) {
			this.setState({
				address: this.props.initialValue,
			});
		}
	}

	handleChange = (address) => {
		this.setState({ streetAddress1: address });
	};

	handleBlur = (e) => {
		const { onSelect } = this.props;
		geocodeByAddress(this.state.address)
			.then((results) => {
				if (results.length === 1) {
					getLatLng(results[0]).then((latLng) => {
						this.updateAddressFields(results[0]);
						onSelect(this.state.address, latLng, this.parseAddress(results[0]));
					});
				}
			})
			.catch((error) => console.log(error));
	};

	handleSelect = (address) => {
		const { onSelect } = this.props;
		this.setState({ address });
		geocodeByAddress(address)
			.then((results) => {
				this.updateAddressFields(results[0]);
				getLatLng(results[0]).then((latLng) => {
					onSelect(address, latLng, this.parseAddress(results[0]));
				});
			})
			.catch((error) => console.log(error));
	};

	updateAddressFields = (result) => {
		const parsedAddressComponents = result.address_components.reduce((acc, ac) => {
			ac.types.map((t) => (acc[t] = ac.long_name));
			return acc;
		}, {});

		this.setState({
			streetAddress1: [parsedAddressComponents.street_number, parsedAddressComponents.route].join(
				' '
			),
			city: nullSafeGetOrElse(
				'locality',
				parsedAddressComponents,
				nullSafeGetOrElse(
					'sublocality',
					parsedAddressComponents,
					nullSafeGetOrElse(
						'neighborhood',
						parsedAddressComponents,
						nullSafeGetOrElse(
							'administrative_area_level_3',
							parsedAddressComponents,
							parsedAddressComponents.administrative_area_level_2
						)
					)
				)
			),
			region: parsedAddressComponents.administrative_area_level_1,
			postcode: parsedAddressComponents.postal_code,
		});
	};

	parseAddress = (result) => {
		const parsedAddressComponents = result.address_components.reduce((acc, ac) => {
			ac.types.map((t) => (acc[t] = ac.long_name));
			return acc;
		}, {});

		return {
			streetAddress1: [parsedAddressComponents.street_number, parsedAddressComponents.route].join(
				' '
			),
			streetAddress2Opt: this.state.streetAddress2Opt || '',
			city: nullSafeGetOrElse(
				'locality',
				parsedAddressComponents,
				nullSafeGetOrElse(
					'sublocality',
					parsedAddressComponents,
					nullSafeGetOrElse(
						'neighborhood',
						parsedAddressComponents,
						nullSafeGetOrElse(
							'administrative_area_level_3',
							parsedAddressComponents,
							parsedAddressComponents.administrative_area_level_2
						)
					)
				)
			),
			region: parsedAddressComponents.administrative_area_level_1,
			postcode: parsedAddressComponents.postal_code,
			country: parsedAddressComponents.country,
		};
	};

	render() {
		const { placeholder, lat, lon, disabled } = this.props;
		const { streetAddress1, streetAddress2Opt, city, region, postcode } = this.state;
		return (
			<div>
				<div className="flex flex-row gap-x-4">
					<PlacesAutocomplete
						disabled={disabled}
						value={this.state.streetAddress1}
						onChange={this.handleChange}
						onSelect={this.handleSelect}
						searchOptions={{ types: ['address'] }}
					>
						{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
							<div className="locationAutocomplete__container" style={{ minWidth: '50%' }}>
								<Input
									size={this.props.size}
									{...getInputProps({
										onBlur: this.handleBlur,
										placeholder: placeholder,
										className: 'location-search-input',
										autoComplete: 'random',
									})}
									disabled={disabled}
								/>
								{loading ? (
									<Spin style={{ position: 'absolute', right: 8, top: 12 }} size="small" />
								) : null}
								{suggestions.length > 0 ? (
									<div className="locationAutocomplete__dropdownContainer">
										{suggestions.map((suggestion) => {
											const className = suggestion.active
												? 'locationAutocomplete__suggestionItem--active'
												: 'locationAutocomplete__suggestionItem';
											return (
												<div
													{...getSuggestionItemProps(suggestion, {
														className,
														style,
													})}
												>
													<span>{suggestion.description}</span>
												</div>
											);
										})}
									</div>
								) : null}
							</div>
						)}
					</PlacesAutocomplete>
					<Input
						disabled={disabled}
						placeholder="PO#, Apt, suite, unit, building, floor, etc."
						value={streetAddress2Opt}
						onChange={(e) => this.setState({ streetAddress2Opt: e.target.value })}
						onBlur={this.handleBlur}
					/>
				</div>

				<div className="flex flex-row gap-x-4">
					<Input
						disabled
						placeholder="City"
						value={`${city} ${region} ${postcode}`}
						onChange={(e) => this.setState({ city: e.target.value })}
						style={{ marginTop: 16 }}
						onBlur={this.handleBlur}
					/>
				</div>

				{lon && lat ? (
					<div style={{ height: 240, width: 240, marginTop: 16, position: 'relative' }}>
						<Mapbox longitude={lon} latitude={lat} baseLayerStyle="light" zoomLevel={7} />
					</div>
				) : null}
			</div>
		);
	}
}
